import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { TankService } from "@services/tank.service";
import { AppDialogService } from '@services/app-dialog.service';
import { take } from "rxjs/operators";
import { IGlobalTankSearchOption } from "@interfaces/globalTankSearchOptions";
import { LogService } from "@services/log.service";
import { GlobalTankSearchResultComponent } from "./global-tank-search-results.component";

@Component({
  selector: "global-tank-search",
  templateUrl: "./global-tank-search.component.html",
  styleUrls: ["./global-tank-search.component.css"],
})
/** global-tank-search component*/
export class GlobalTankSearchComponent implements OnInit {
  selectedSearchType = '0';
  searchValue = '';
  searching = false;

  /** global-tank-search ctor */
  constructor(
    private appDialogService: AppDialogService,
    private matDialog: MatDialog,
    private tankService: TankService,
    private logger: LogService,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {}

  public onSearch() {
    //validate the search value. Must contain a min number of characters
    const minCharLengthAllowed = 3;
    if (this.searchValue.length < minCharLengthAllowed) {
      return;
    }

    let payload: IGlobalTankSearchOption = {
      searchType: this.selectedSearchType,
      searchValue: this.searchValue
    }
    this.searching = true;

    this.tankService
      .searchForTanks(payload)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.searching = false;
          //no tanks found
          if (data.length === 0) {
            const searchTypeTranslated = this.getSearchTypeTranslated(payload.searchType);
            this.appDialogService.showErrorMessage(
              `No tanks found for ${searchTypeTranslated} '${payload.searchValue}'`
            );
          }

          //display the search results in a dialog box
          this.logger.log("Tank Search Results", data);
          this.matDialog.open(GlobalTankSearchResultComponent, {
            panelClass: "searchResult",
            data: data,
          });
        },
        (e) => {
          this.searching = false;
          const searchTypeTranslated = this.getSearchTypeTranslated(payload.searchType);
          this.appDialogService.showErrorMessage(
            `An error occured while searching for ${searchTypeTranslated} '${payload.searchValue}'`
          );
        }
      );
  }

  private getSearchTypeTranslated(searchType: string): string {
    switch (searchType) {
      case '0':
        return this.translate.instant('Header.SerialNumber');
      case '1':
        return this.translate.instant('Header.MinNumber');
      case '2':
        return this.translate.instant('Header.TankName');
      case '3':
        return this.translate.instant('Header.Location');
    }
    return '';
  }

}
